import React from "react";
import { devError } from "../lib/devLog";

// Self-contained (no i18n import) so it still renders if the dictionary itself crashed.
const CRASH_COPY = {
  en: ["Something went wrong", "This page could not be displayed. Your orders and basket are safe.", "Reload", "Home"],
  fr: ["Un petit souci est survenu", "La page n'a pas pu s'afficher. Vos commandes et votre panier sont conservés.", "Recharger", "Accueil"],
  es: ["Algo salió mal", "No se pudo mostrar esta página. Sus pedidos y su cesta están a salvo.", "Recargar", "Inicio"],
  it: ["Qualcosa è andato storto", "Impossibile visualizzare questa pagina. I suoi ordini e il carrello sono al sicuro.", "Ricarica", "Home"],
  nl: ["Er ging iets mis", "Deze pagina kon niet worden weergegeven. Uw bestellingen en winkelmand zijn veilig.", "Opnieuw laden", "Home"],
  de: ["Etwas ist schiefgelaufen", "Diese Seite konnte nicht angezeigt werden. Ihre Bestellungen und Ihr Warenkorb sind sicher.", "Neu laden", "Startseite"],
  ar: ["حدث خطأ ما", "تعذّر عرض هذه الصفحة. طلباتك وسلتك محفوظة.", "إعادة التحميل", "الرئيسية"],
};


export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    devError("[fleurinelle] render crash", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const lang = (window.location.pathname.split("/")[1] || "en");
    const c = CRASH_COPY[lang] || CRASH_COPY.en;
    return (
      <div className="min-h-screen bg-plaster flex items-center justify-center p-6" data-testid="app-error-boundary">
        <div className="max-w-md w-full bg-white border border-brass-light p-8 space-y-4 text-center rounded-sm">
          <h1 className="font-display text-2xl text-ink">{c[0]}</h1>
          <p className="text-sm text-muted">{c[1]}</p>
          <div className="flex gap-2 justify-center">
            <button className="btn-primary" data-testid="error-reload" onClick={() => window.location.reload()}>
              {c[2]}
            </button>
            <a className="btn-ghost" href="/" data-testid="error-home">{c[3]}</a>
          </div>
        </div>
      </div>
    );
  }
}
